/**
 * judgeme-rating-summary.js
 *
 * Adds a compact rating summary — e.g. "4.5(12)" — next to the Judge.me
 * preview-badge stars in product cards. The figures are read from the badge's
 * own `data-average-rating` / `data-number-of-reviews` attributes, so they stay
 * in sync with whatever Judge.me renders.
 *
 * Handles cards injected after initial load (collection AJAX filtering,
 * quick view, infinite scroll) via a MutationObserver.
 */
(function () {
  'use strict';

  var PROCESSED_ATTR = 'data-bls-rating-summary';

  function formatAverage(raw) {
    var value = parseFloat(raw);
    if (isNaN(value)) return null;
    // One decimal place, with a trailing ".0" trimmed (4.50 -> "4.5", 5 -> "5").
    return parseFloat(value.toFixed(1)).toString();
  }

  function enhance(badge) {
    if (!badge || badge.getAttribute(PROCESSED_ATTR) === 'true') return;

    // Only product cards get the summary. The product detail page (PDP)
    // already shows the review count in its star widget, so badges outside a
    // product-card wrapper are left untouched.
    if (!badge.closest || !badge.closest('.bls__product-item')) return;

    var average = formatAverage(badge.getAttribute('data-average-rating'));
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);

    // Nothing to show until reviews exist.
    if (average === null || isNaN(count) || count <= 0) return;

    badge.setAttribute(PROCESSED_ATTR, 'true');

    var summary = document.createElement('span');
    summary.className = 'bls__rating-summary';

    var avgEl = document.createElement('span');
    avgEl.className = 'bls__rating-summary__average';
    avgEl.textContent = average;

    var countEl = document.createElement('span');
    countEl.className = 'bls__rating-summary__count';
    countEl.textContent = '(' + count + ')';

    summary.appendChild(avgEl);
    summary.appendChild(countEl);

    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    if (stars && stars.parentNode) {
      stars.parentNode.insertBefore(summary, stars.nextSibling);
    } else {
      badge.appendChild(summary);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('.jdgm-prev-badge:not([' + PROCESSED_ATTR + '])');
    for (var i = 0; i < badges.length; i++) {
      enhance(badges[i]);
    }
    // `root` itself might be a badge (e.g. when added directly).
    if (root && root.classList && root.classList.contains('jdgm-prev-badge')) {
      enhance(root);
    }
  }

  function init() {
    scan(document);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
